import { ChakraBox, FAIconName, FireflyButton, Text } from '@equip.health/ui';
import { CarePlanQolGoalResponse } from '~/lib/types/carePlan/carePlans';
import { CarePlanDescriptionRow } from './CarePlanDescriptionRow';

type Props = {
  qolGoal: CarePlanQolGoalResponse;
  onAddDescriptionClick: (qolGoal: CarePlanQolGoalResponse) => void;
};

export const CarePlanQoLGoalExpandedView = ({
  qolGoal,
  onAddDescriptionClick,
}: Props) => {
  const isSavedDescriptionDetailsPresent = Boolean(
    qolGoal.descriptionDetails?.description?.trim(),
  );
  const isSavedDescriptionPresent = Boolean(qolGoal.description?.trim());

  if (isSavedDescriptionDetailsPresent) {
    return (
      <ChakraBox pb="18px">
        <CarePlanDescriptionRow
          descriptionDetails={qolGoal.descriptionDetails}
          goalId={qolGoal.id}
        />
      </ChakraBox>
    );
  }

  if (isSavedDescriptionPresent) {
    return (
      <ChakraBox pb="18px">
        <Text>{qolGoal.description}</Text>
      </ChakraBox>
    );
  }

  return (
    <ChakraBox pb="18px">
      <FireflyButton
        id={`care-plan-qol-goal-${qolGoal.id}__add-desc-btn`}
        leftIcon={FAIconName.plusRegular}
        onClick={() => onAddDescriptionClick(qolGoal)}
        variant="tertiary"
      >
        Add goal description
      </FireflyButton>
    </ChakraBox>
  );
};
